/* Native invoice-request attributes; no invoice issuing or accounting backend. */
(() => {
 'use strict';
 const fields=['fe-richiesta','fe-tipo-cliente','fe-azienda','fe-codice-fiscale','fe-piva','fe-sdi','fe-pec','fe-cig','fe-cup','fe-pagamenti-separati'];
 const business=['fe-azienda','fe-codice-fiscale','fe-piva','fe-sdi','fe-pec'];
 const types={private:['fe-codice-fiscale'],company:business,'public-administration':[...business,'fe-cig','fe-cup','fe-pagamenti-separati'],'no-profit':business};
 const value=(data,key)=>String(data[key]??'');
 function visible(data){
  const result=new Set(['fe-richiesta']);
  if(value(data,'fe-richiesta')==='Yes'){result.add('fe-tipo-cliente');const type=value(data,'fe-tipo-cliente');for(const key of Object.prototype.hasOwnProperty.call(types,type)?types[type]:[])result.add(key);}
  return result;
 }
 function attributes(data){const active=visible(data);return Object.fromEntries(fields.map(key=>[key,active.has(key)?value(data,key):'']));}
 const fiscalCode=/^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
 const vat=/^([a-zA-Z]{2})?[0-9]{11}$/;
 const email=/^[a-zA-Z0-9.!#$%&'*+/=?^_\x60{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
 function validate(data,required=false){
  const issue=(field,message)=>({field,message:'liotro.invoice.'+message});
  if(value(data,'fe-richiesta')!=='Yes')return required?issue('fe-richiesta','required'):null;
  const type=value(data,'fe-tipo-cliente');
  if(!Object.prototype.hasOwnProperty.call(types,type))return issue('fe-tipo-cliente','choose_type');
  const cf=value(data,'fe-codice-fiscale'),tax=value(data,'fe-piva'),pec=value(data,'fe-pec'),sdi=value(data,'fe-sdi');
  if(type==='private'){
   if(!cf.trim())return issue('fe-codice-fiscale','cf_required');
   return fiscalCode.test(cf)?null:issue('fe-codice-fiscale','cf_invalid');
  }
  if(!value(data,'fe-azienda').trim())return issue('fe-azienda','company_required');
  if(!cf.trim()&&!tax.trim())return issue('fe-piva','tax_required');
  if(cf.trim()&&!fiscalCode.test(cf)&&!(type==='company'&&cf.trim()===tax.trim()))return issue('fe-codice-fiscale','cf_invalid');
  if(tax.trim()&&!vat.test(tax))return issue('fe-piva','vat_invalid');
  if(!pec.trim()&&!sdi.trim())return issue('fe-pec','routing_required');
  if(pec.trim()&&!email.test(pec))return issue('fe-pec','pec_invalid');
  if(sdi.trim()&&!/^[a-zA-Z0-9]{7}$/.test(sdi))return issue('fe-sdi','sdi_invalid');
  if(type==='public-administration'){
   if(value(data,'fe-cig').trim()&&!/^[a-z0-9]{10}$/.test(value(data,'fe-cig')))return issue('fe-cig','cig_invalid');
   if(value(data,'fe-cup').trim()&&!/^[a-z0-9]{15}$/.test(value(data,'fe-cup')))return issue('fe-cup','cup_invalid');
  }
  return null;
 }
 function createSaver({read,write,changed=()=>{},failed=()=>{}}){
  const fingerprint=()=>JSON.stringify(attributes(read()));
  let saved=fingerprint(),tail=Promise.resolve(),pending=0,error=null,lastSignature=null,lastWork=null;
  const dirty=()=>fingerprint()!==saved;
  function save(){
   const payload=attributes(read()),signature=JSON.stringify(payload);
   if(pending&&signature===lastSignature)return lastWork;
   if(!pending&&!error&&signature===saved)return Promise.resolve();
   pending++;lastSignature=signature;changed();
   const request=tail.then(()=>write(payload));
   lastWork=request.then(result=>{saved=signature;error=null;return result;},problem=>{error=problem;failed(problem);throw problem;}).finally(()=>{pending--;changed();});
   tail=lastWork.catch(()=>{});return lastWork;
  }
  return {save,dirty,pending:()=>pending,error:()=>error,notify:changed,ready:()=>!pending&&!error&&!dirty()};
 }
 window.LiotroInvoice={fields,types,visible,attributes,validate,createSaver};
 if(typeof document==='undefined'||!window.LiotroLifecycle||!window.LiotroCommerce)return;
 const paused=node=>node?.closest('[data-liotro-paused]')?.dataset.liotroPaused==='true'||typeof cfg!=='undefined'&&cfg.paused;
 const instances=window.LiotroLifecycle.create({selector:'[data-liotro-invoice]',setup(root){
  const controls=[...root.querySelectorAll('[data-invoice-key]')],status=root.querySelector('[data-invoice-status]'),retry=root.querySelector('[data-invoice-retry]');
  let disposed=false,messageKind='';
  const required=root.dataset.required==='true';
  function read(){
   const data={};
   for(const field of controls){
    const key=field.dataset.invoiceKey;
    if(field.type==='radio'){if(field.checked)data[key]=field.value;}
    else data[key]=field.type==='checkbox'?(field.checked?field.value:''):field.value;
   }
   return data;
  }
  function message(key,kind){
   if(disposed)return;messageKind=kind;status.textContent=key?window.LiotroText(key):'';status.hidden=!key;retry.hidden=kind!=='save';
  }
  const saver=createSaver({read,write:attrs=>window.LiotroCommerce.update({attributes:attrs},{renderSections:false}),
   changed(){if(disposed)return;gates();if(!saver.error()&&messageKind==='save')message('','');},
   failed(){message('liotro.invoice.save_failed','save');}});
  function gates(){
   const cart=root.closest('[data-liotro-cart-main]'),wallet=cart?.querySelector('[data-liotro-invoice-wallets]');
   if(wallet)wallet.hidden=paused(cart)||!saver.ready()||window.LiotroNotes?.ready?.()===false||Boolean(validate(read(),required));
   root.toggleAttribute('data-invoice-saving',saver.pending()>0);
  }
  function view(){
   const data=read(),active=visible(data),requested=data['fe-richiesta']==='Yes';
   root.querySelector('[data-invoice-details]').hidden=!requested;
   for(const field of controls){
    const key=field.dataset.invoiceKey,enabled=active.has(key);
    field.disabled=!enabled;
    if(field.type!=='radio'&&key!=='fe-richiesta')field.closest('[data-invoice-field]').hidden=!enabled;
    if(field.type==='radio')field.required=requested;
    else field.required=key==='fe-richiesta'?required:requested&&(data['fe-tipo-cliente']==='private'&&key==='fe-codice-fiscale'||data['fe-tipo-cliente']!=='private'&&key==='fe-azienda');
   }
   root.querySelector('[data-invoice-key="fe-richiesta"]').setAttribute('aria-expanded',String(requested));
   for(const fallback of root.querySelectorAll('[data-invoice-empty]')){
    const key=fallback.dataset.invoiceEmpty;
    fallback.disabled=active.has(key)&&Boolean(data[key]);
    if(key!=='fe-richiesta'&&key!=='fe-pagamenti-separati'&&key!=='fe-tipo-cliente')fallback.disabled=active.has(key);
   }
   gates();
  }
  function invalid(issue){
   message(issue.message,'validation');
   const field=controls.find(field=>field.dataset.invoiceKey===issue.field&&!field.disabled);
   field?.focus({preventScroll:false});
  }
  const input=event=>{if(!event.target.matches('[data-invoice-key]'))return;if(messageKind==='validation')message('','');gates();};
  const change=event=>{if(!event.target.matches('[data-invoice-key]'))return;view();saver.save().catch(()=>{});};
  const keydown=event=>{if(event.key!=='Enter'||!event.target.matches('input[type="text"],input[type="email"]'))return;event.preventDefault();const form=document.getElementById('LiotroCart'),button=form?.querySelector('button[name="checkout"]');if(button&&!button.disabled)form.requestSubmit(button);};
  const retrySave=()=>saver.save().catch(()=>{});
  root.addEventListener('input',input);root.addEventListener('change',change);root.addEventListener('keydown',keydown);retry.addEventListener('click',retrySave);
  view();
  return {read,validate:()=>validate(read(),required),invalid,save:()=>saver.save(),ready:()=>saver.ready(),changed(){view();},
   changedDuringSubmit(){message('liotro.invoice.changed','validation');},
   dispose(){disposed=true;root.removeEventListener('input',input);root.removeEventListener('change',change);root.removeEventListener('keydown',keydown);retry.removeEventListener('click',retrySave);}};
 }});
 Object.assign(window.LiotroInvoice,instances);
 const passOnce=new WeakSet(),submitting=new WeakSet();
 document.addEventListener('submit',event=>{
  const form=event.target,submitter=event.submitter;
  if(event.defaultPrevented)return;
  if(form.id!=='LiotroCart'||submitter?.name!=='checkout')return;
  if(passOnce.has(form)){passOnce.delete(form);return;}
  const root=form.closest('[data-liotro-cart-main]')?.querySelector('[data-liotro-invoice]'),instance=root&&instances.get(root);if(!instance)return;
  if(submitting.has(instance)){event.preventDefault();return;}
  const issue=instance.validate();if(issue){event.preventDefault();instance.invalid(issue);return;}
  if(instance.ready())return;
  event.preventDefault();submitting.add(instance);
  submitter.setAttribute('aria-busy','true');submitter.setAttribute('data-invoice-checkout-busy','');
  instance.save().then(()=>{
   const current=document.getElementById('LiotroCart'),button=current?.querySelector('button[name="checkout"]');
   if(!current||!root.isConnected||!button||button.disabled||paused(current))return;
   const issue=instance.validate();if(issue){instance.invalid(issue);return;}
   if(!instance.ready()){instance.changedDuringSubmit();return;}
   passOnce.add(current);try{current.requestSubmit(button);}finally{passOnce.delete(current);}
  }).catch(()=>{}).finally(()=>{
   submitting.delete(instance);const current=document.getElementById('LiotroCart'),button=current?.querySelector('button[name="checkout"]');
   for(const node of new Set([submitter,button]))if(node?.hasAttribute('data-invoice-checkout-busy')){node.removeAttribute('aria-busy');node.removeAttribute('data-invoice-checkout-busy');}
  });
 },true);
 instances.mount(document);
})();
